import { useContext } from 'react';
import { AudioPlayerContext } from './AudioPlayerProvider';
import type { AudioPlayerContextValue } from './types';

export function useAudioPlayer(): AudioPlayerContextValue {
  const ctx = useContext(AudioPlayerContext);
  if (!ctx) throw new Error('useAudioPlayer must be used within <AudioPlayerProvider>');
  return ctx;
}
